/* Turning a stored notification into the two labels the drawer shows.
 *
 * Both are presentation only — nothing here changes what is fetched, stored or
 * marked read.
 */

/* The chip above each row. The API's `type` is the same set the rail's dots key off (see Hooks/u1/useDashboardNav ALERT_TYPE_MAPPING); this names it for a... */
export const SECTION_LABELS = {
  request: "Requests",
  follow: "Following",
  payment: "Billing",
  order_request: "Purchased",
  enterprise: "Enterprise",
  support_ticket: "Support",
};

export const sectionLabel = (type) => SECTION_LABELS[type] || "General";

const MINUTE = 60 * 1000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/* "2h ago" / "Yesterday" / "3d ago" / "Last week", as the design writes them. */
export const relativeTime = (value, now = Date.now()) => {
  if (!value) return "";
  const then = new Date(value).getTime();
  if (Number.isNaN(then)) return "";

  const diff = now - then;
  if (diff < MINUTE) return "Just now";
  if (diff < HOUR) return `${Math.floor(diff / MINUTE)}m ago`;
  if (diff < DAY) return `${Math.floor(diff / HOUR)}h ago`;

  const days = Math.floor(diff / DAY);
  if (days === 1) return "Yesterday";
  if (days < 7) return `${days}d ago`;
  if (days < 14) return "Last week";
  if (days < 31) return `${Math.floor(days / 7)}w ago`;

  return new Date(then).toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};
